import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { zip } from 'rxjs';

@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss']
})
export class InfoDialogComponent {

  title: string;
  message: string;
  closeText: string;

  constructor(
    public dialogRef: MatDialogRef<InfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, public translate: TranslateService) {
    zip(
      this.translate.get(data.title || 'account.information'),
      this.translate.get(data.message || 'account.information'),
      this.translate.get(data.closeText || 'account.ok')
    ).subscribe(
      ([title, message, close]: [string, string, string]) => {
        this.title = title;
        this.message = message;
        this.closeText = close;
      }
    );
  }

}
